import React, { useEffect, useState } from 'react';
import { Form, Input, Layout, message, Radio } from 'antd';
import { get } from 'lodash';

import PdButton from 'components/pd-button';
import PdUploader from 'components/pd-uploader';

import CourierApi from 'services/courier';
import { errHandling } from 'utils';

import 'react-quill-new/dist/quill.snow.css';
import './style.scss';
import { useLocation, useNavigate } from 'react-router-dom';

const { Content } = Layout;

const FIELDS = {
  CODE: 'code',
  DESKTOP_MEDIA_URL: 'logo_url',
  IS_RENT: 'rent',
  TITLE: 'title',
};

export function CourierCreateEdit() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [formLayout] = useState('vertical');
  const [loadingButton, setLoadingButton] = useState(false);
  const [value, setValue] = useState({});
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id');
  const formItemLayout =
    formLayout === 'horizontal'
      ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 },
        }
      : null;

  const buttonItemLayout =
    formLayout === 'horizontal'
      ? {
          wrapperCol: { span: 14, offset: 4 },
        }
      : null;

  function handleChangeValue(url, key) {
    setValue((prevState) => ({
      ...prevState,
      [key]: url,
    }));
  }

  async function showCourier(id) {
    try {
      const { data } = await CourierApi.showCourier(id);
      const courierData = data.data;
      setValue(courierData);
    } catch (error) {
      errHandling(error);
    }
  }

  async function handleSubmit(values) {
    try {
      setLoadingButton(true);
      if (id) {
        values.weight = Number(values.weight) * 1000;
        await CourierApi.updateCourier(id, { ...value, ...values });
        message.success('Successfully updated courier');
      } else {
        message.success('Successfully created courier');
      }
      navigate({
        pathname: '/couriers',
      });
    } catch (err) {
      message.error(
        get(
          err,
          'response.data.message',
          'Cannot connect to server, please check connection'
        )
      );
    } finally {
      setLoadingButton(false);
    }
  }

  function changeValue(key, e) {
    if (e) {
      setValue((prevState) => ({
        ...prevState,
        [key]: e,
      }));
    }
  }

  useEffect(() => {
    if (id) {
      showCourier(id);
    } else {
      setValue([]);
    }
  }, [id]);

  useEffect(() => {
    if (id && value.title) {
      form.setFieldsValue({
        [FIELDS.TITLE]: value[FIELDS.TITLE],
        [FIELDS.IS_RENT]: value[FIELDS.IS_RENT],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, id]);

  return (
    <Layout className="pd-cms-courier main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">{id ? 'Edit' : 'Create New'} Courier</div>
          <Content className="pageContent">
            <Form
              form={form}
              layout={formLayout}
              onFinish={handleSubmit}
              initialValues={value}>
              <div className="section-container">
                <div className="inner-section">
                  <Form.Item
                    label="Title"
                    name={FIELDS.TITLE}
                    rules={[{ message: 'Please input Title!', required: true }]}
                    {...formItemLayout}>
                    <Input
                      onChange={changeValue.bind(this, FIELDS.TITLE)}
                      placeholder="Write Courier title here"
                      value={value[FIELDS.TITLE]}
                    />
                  </Form.Item>
                  <Form.Item label="Courier Logo" {...formItemLayout}>
                    <PdUploader
                      afterUpload={handleChangeValue}
                      imgClassName="w-30"
                      imgUrl={value[FIELDS.DESKTOP_MEDIA_URL]}
                      keyValue={FIELDS.DESKTOP_MEDIA_URL}
                      name="Foto Courier"
                    />
                  </Form.Item>

                  <Form.Item
                    name={FIELDS.IS_RENT}
                    rules={[
                      {
                        message: 'Please select renting Availablity!',
                        required: true,
                      },
                    ]}
                    {...formItemLayout}>
                    <Radio.Group
                      onChange={changeValue.bind(this, FIELDS.IS_RENT)}
                      value={value[FIELDS.IS_RENT]}>
                      <Radio value={false}>Not available for rent</Radio>
                      <Radio value={true}>Available for rent</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                <Form.Item {...buttonItemLayout}>
                  <div className="buttonSection mt-40">
                    <PdButton
                      full
                      htmlType="submit"
                      loading={loadingButton}
                      type="primary">
                      Publish
                    </PdButton>
                  </div>
                </Form.Item>
              </div>
            </Form>
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default CourierCreateEdit;
